import { Container } from './style';

function InteractionBtn() {
  return (
    <Container>
    
    </Container>
  );
}

export default InteractionBtn;
